import script from "./sw-item-viewer-label.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer-label.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer-label.vue?vue&type=style&index=0&id=f91e428e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f91e428e"]])

export default __exports__